export default {
  suppressedEmails: [],
  isLoading: false,
  error: null
};